<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            {{ title }}
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
    </v-card>

    <div v-if="loading && id" class="text-center py-12">
      <v-progress-circular size="50" color="primary" indeterminate />
    </div>

    <v-container v-else class="px-7" fluid>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="auto" v-if="id">
          <v-btn
            to="/sshcf/requests"
            class="mr-2"
            color="bluedarken"
            exact
            icon
          >
            <v-icon class="icon-bold">mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            <template v-if="isRevise || hasRevision">
              <template v-if="hasRevision">
                {{ formRequest.hcf_code }}
                <span class="menuActive--text">
                  Revision For {{ formRequest.revision.hcf_code }}
                </span>
              </template>
              <template v-else>
                <span class="menuActive--text">
                  Revision For {{ formRequest.hcf_code }}
                </span>
              </template>
            </template>
            <template v-else>
              {{ subtitle }}
            </template>
          </h1>
        </v-col>
        <v-spacer v-if="id" />
        <v-col cols="12" sm="auto">
          <v-btn
            v-if="canRevise"
            type="button"
            class="btn-medium mr-2"
            @click="revise"
          >
            {{ isRevise ? 'Cancel' : 'Revise' }}
          </v-btn>
          <v-btn
            depressed
            dark
            type="button"
            color="menuActive"
            class="btn-medium"
            :loading="generating"
            @click="generateMOU"
          >
            <v-icon class="mr-2" large>mdi-refresh</v-icon>
            Generate MOU
          </v-btn>
          <!--          <v-btn type="button" color="primary" icon large>-->
          <!--            <v-icon large>mdi-refresh</v-icon>-->
          <!--          </v-btn>-->
        </v-col>
      </v-row>

      <v-alert
        :value="isEditing && isNotOwner"
        type="error"
        class="fs-14 mt-4 white--text"
        color="warning"
      >
        You are not authorized to edit this draft
      </v-alert>

      <ValidationObserver ref="form" v-slot="{ handleSubmit, invalid }">
        <form
          novalidate
          autocomplete="off"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          <v-card class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              Requester
            </v-card-title>
            <v-card-text class="black--text pt-4 pb-0">
              <v-row dense align="center">
                <v-col
                  offset="0"
                  offset-sm="2"
                  offset-md="3"
                  cols="12"
                  sm="8"
                  md="6"
                >
                  <label
                    class="mb-1 d-block fs-12 font-weight-regular"
                    for="region"
                  >
                    Region
                  </label>
                  <ValidationProvider
                    slim
                    name="Region"
                    :rules="rules.region"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      id="region"
                      placeholder="Input Region"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.requestor.region"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      autocomplete="off"
                      :items="regions"
                      item-value="r_name"
                      item-text="r_name"
                    ></v-autocomplete>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="District"
                    :rules="rules.district"
                    v-slot="{ errors }"
                  >
                    <label
                      for="district"
                      class="mb-1 d-block fs-12 font-weight-regular"
                      >District</label
                    >
                    <v-autocomplete
                      id="district"
                      placeholder="Input District"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.requestor.district"
                      autocomplete="off"
                      :items="districts"
                      item-value="d_name"
                      item-text="d_name"
                      :disabled="districts.length < 1 || isDisabled"
                      :filled="districts.length < 1 || isDisabled"
                    ></v-autocomplete>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="District Manager"
                    :rules="rules.district_manager"
                    v-slot="{ errors }"
                  >
                    <label
                      for="district_manager"
                      class="mb-1 d-block fs-12 font-weight-regular"
                      >District Manager</label
                    >

                    <v-text-field
                      id="district_manager"
                      placeholder="Input District Manager"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.requestor.district_manager"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              General Information
            </v-card-title>
            <v-card-text class="black--text pt-4 pb-0">
              <v-row align="center">
                <v-col
                  offset="0"
                  offset-sm="2"
                  offset-md="3"
                  cols="12"
                  sm="8"
                  md="6"
                >
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    v-model="menu"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        slim
                        name="Created Date"
                        :rules="rules.createdDate"
                        v-slot="{ errors }"
                      >
                        <label
                          for="createdDate"
                          class="mb-1 d-block fs-12 font-weight-regular"
                        >
                          Created Date
                        </label>
                        <v-text-field
                          id="createdDate"
                          placeholder="Created Date"
                          append-icon="event"
                          single-line
                          dense
                          outlined
                          readonly
                          v-on="on"
                          :error-messages="errors"
                          v-model="form.general_information.created_date"
                          :disabled="isDisabled"
                          :filled="isDisabled"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="form.general_information.created_date"
                      :min="minDate"
                      @input="menu = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>

                  <ValidationProvider
                    slim
                    name="Preval Number"
                    :rules="rules.prevalNumber"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="preval_number"
                    >
                      Preval Number
                    </label>
                    <v-text-field
                      id="preval_number"
                      placeholder="Input Preval Number"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.general_information.preval_number"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider slim name="PO Number" v-slot="{ errors }">
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="PONumber"
                    >
                      PO Number
                    </label>
                    <v-text-field
                      id="PONumber"
                      placeholder="Input PO Number"
                      single-line
                      dense
                      outlined
                      disabled
                      filled
                      :error-messages="errors"
                      v-model="form.general_information.po_number"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="GL Account"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="gl_account"
                    >
                      GL Account
                    </label>
                    <v-text-field
                      id="gl_account"
                      placeholder="Input GL Account"
                      single-line
                      dense
                      outlined
                      disabled
                      filled
                      :error-messages="errors"
                      v-model="form.general_information.gl_account"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Cost Center"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="cost_center"
                    >
                      Cost Center
                    </label>
                    <v-text-field
                      id="cost_center"
                      placeholder="Cost Center"
                      single-line
                      dense
                      outlined
                      disabled
                      filled
                      :error-messages="errors"
                      v-model="form.general_information.cost_center"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="IO Number"
                    :rules="rules.ioNumber"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="io_number"
                    >
                      IO Number
                    </label>
                    <v-autocomplete
                      id="io_number"
                      placeholder="IO Number"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.general_information.io_number"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      :items="ioNumbers"
                      item-text="io_number"
                      item-value="io_number"
                      :hide-details="!!ioWarning"
                      return-object
                      clearable
                    ></v-autocomplete>

                    <div v-if="ioWarning" class="mt-4 mb-4 fs-12 warning--text">
                      {{ ioWarning }}
                    </div>
                    <div v-else class="mb-4 fs-12 info--text">
                      {{ form.general_information.io_number.activity_desc }}
                    </div>
                  </ValidationProvider>

                  <!--                  <ValidationProvider-->
                  <!--                    slim-->
                  <!--                    name="IO Description"-->
                  <!--                    :rules="rules.ioDescription"-->
                  <!--                    v-slot="{ errors }"-->
                  <!--                  >-->
                  <!--                    <label-->
                  <!--                      class="mb-1 d-block fs-12 font-weight-regular"-->
                  <!--                      for="io_description"-->
                  <!--                    >-->
                  <!--                      IO Description-->
                  <!--                    </label>-->
                  <!--                    <v-textarea-->
                  <!--                      id="io_description"-->
                  <!--                      placeholder="IO Description"-->
                  <!--                      single-line-->
                  <!--                      dense-->
                  <!--                      outlined-->
                  <!--                      :error-messages="errors"-->
                  <!--                      v-model="form.general_information.io_description"-->
                  <!--                      :disabled="isDisabled"-->
                  <!--                      :filled="isDisabled"-->
                  <!--                    ></v-textarea>-->
                  <!--                  </ValidationProvider>-->

                  <ValidationProvider
                    slim
                    name="Amount of Support"
                    :rules="rules.amountOfSupport"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="amountOfSupport"
                    >
                      Amount of Support
                    </label>
                    <v-currency-field
                      id="amountOfSupport"
                      placeholder="Amount of Support"
                      single-line
                      v-model="form.general_information.amount_of_support"
                      :error-messages="errors"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      @input="onAmountOfSupportChanged"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              First Party Information
            </v-card-title>
            <v-card-text class="black--text pt-4 pb-0">
              <v-row dense align="center">
                <v-col
                  offset="0"
                  offset-sm="2"
                  offset-md="3"
                  cols="12"
                  sm="8"
                  md="6"
                >
                  <ValidationProvider
                    slim
                    name="Company Name"
                    :rules="rules.companyName"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="company_name"
                    >
                      Company Name
                    </label>
                    <v-autocomplete
                      id="company_name"
                      placeholder="Company Name"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.first_party_information.company_name"
                      autocomplete="off"
                      :items="companies"
                      item-value="id"
                      item-text="c_name"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      return-object
                    ></v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Company Address"
                    :rules="rules.companyAddress"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="company_address"
                    >
                      Company Address
                    </label>
                    <v-textarea
                      id="company_address"
                      placeholder="Company Address"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.first_party_information.company_address"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-textarea>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Name of Signatory"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="name_of_signatory"
                    >
                      Name of Signatory
                    </label>
                    <v-text-field
                      id="name_of_signatory"
                      placeholder="Name of Signatory"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.first_party_information.name_of_signatory"
                      disabled
                      filled
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Title of Signatory"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      class="mb-1 d-block fs-12 font-weight-regular"
                      for="title_of_signatory"
                    >
                      Title of Signatory
                    </label>
                    <v-text-field
                      id="title_of_signatory"
                      placeholder="Title of Signatory"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.first_party_information.title_of_signatory"
                      disabled
                      filled
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              Second Party Information
            </v-card-title>
            <v-card-text class="black--text pt-4 pb-0">
              <v-row align="start">
                <v-col offset="0" offset-sm="1" cols="12" sm="5">
                  <ValidationProvider
                    slim
                    name="Hospital Name"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label
                      for="hospital_name"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Hospital Name
                    </label>
                    <v-combobox
                      id="hospital_name"
                      placeholder="Input Hospital Name"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.hospital_name"
                      autocomplete="off"
                      :items="hospitals"
                      item-value="id"
                      item-text="h_name"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      return-object
                    ></v-combobox>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Hospital Description"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label
                      for="description"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Hospital Description
                    </label>
                    <v-select
                      id="description"
                      placeholder="Input Hospital Description"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="
                        form.second_party_information.hospital_description
                      "
                      :items="hospitalDescs"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Address"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label for="address" class="fs-12 font-weight-regular mb-1">
                      Address
                    </label>
                    <v-textarea
                      height="188"
                      id="address"
                      placeholder="Input Address"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.hospital_address"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-textarea>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="City"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label for="city" class="fs-12 font-weight-regular mb-1">
                      City
                    </label>
                    <v-text-field
                      id="city"
                      placeholder="Input City"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.hospital_city"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Telephone"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label for="phone" class="fs-12 font-weight-regular mb-1">
                      Telephone
                    </label>
                    <v-text-field
                      id="phone"
                      placeholder="Input Telephone"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.hospital_telephone"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Fax"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label for="fax" class="fs-12 font-weight-regular mb-1">
                      Fax
                    </label>
                    <v-text-field
                      id="fax"
                      placeholder="Input Fax"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.hospital_fax"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    vid="second_party_email"
                    name="Email"
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <label for="email" class="fs-12 font-weight-regular mb-1">
                      Email
                    </label>
                    <v-text-field
                      id="email"
                      placeholder="Input Email"
                      single-line
                      type="email"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.hospital_email"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="5">
                  <ValidationProvider
                    slim
                    name="Vendor Code"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                    vid="second_party_vendor_code"
                  >
                    <label
                      for="vendorName"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Vendor Code
                    </label>
                    <v-combobox
                      id="vendorName"
                      placeholder="Input Vendor Code"
                      single-line
                      type="number"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.vendor_code"
                      autocomplete="off"
                      :items="vendors"
                      item-value="v_code"
                      item-text="v_code"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      return-object
                      @change="onVendorCodeChanged"
                    ></v-combobox>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="Vendor Name"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                    vid="second_party_vendor_name"
                  >
                    <label
                      for="vendorCode"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Vendor Name
                    </label>
                    <v-text-field
                      id="vendorCode"
                      placeholder="Input Vendor Name"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.vendor_name"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="Bank Name"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label
                      for="bankName"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Bank Name
                    </label>
                    <v-text-field
                      id="bankName"
                      placeholder="Input Bank Name"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.bank_name"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="Bank Branch"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label
                      for="bankBranch"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Bank Branch
                    </label>
                    <v-text-field
                      id="bankBranch"
                      placeholder="Input Bank Branch"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.bank_branch"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="Account Number"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label
                      for="accountNumber"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Account Number
                    </label>
                    <v-text-field
                      id="accountNumber"
                      placeholder="Input Account Number"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="
                        form.second_party_information.bank_account_number
                      "
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="Name of Signatory"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label
                      for="nameOfSignatory2"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Name of Signatory
                    </label>
                    <v-text-field
                      id="nameOfSignatory2"
                      placeholder="Input Name of Signatory"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.signatory_name"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="Title of Signatory"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label
                      for="titleOfSignatory2"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Title of Signatory
                    </label>
                    <v-text-field
                      id="titleOfSignatory2"
                      placeholder="Input Title of Signatory"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.signatory_title"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    slim
                    name="Remarks"
                    :rules="rules.second_party_information"
                    v-slot="{ errors }"
                  >
                    <label for="remarks" class="fs-12 font-weight-regular mb-1">
                      Remarks
                    </label>
                    <v-textarea
                      id="remarks"
                      placeholder="Input Remarks"
                      single-line
                      rows="3"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.second_party_information.remarks"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              Agreement Information
            </v-card-title>
            <v-card-text class="black--text pt-4 pb-0">
              <v-row dense align="center">
                <v-col
                  offset="0"
                  offset-sm="2"
                  offset-md="3"
                  cols="12"
                  sm="8"
                  md="6"
                >
                  <v-menu
                    v-model="menuAgreementStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        slim
                        vid="agreement_start_date"
                        name="Start Date"
                        :rules="rules.agreementStartDate"
                        v-slot="{ errors }"
                      >
                        <label
                          for="startDate"
                          class="fs-12 font-weight-regular mb-1"
                        >
                          Start Date
                        </label>
                        <v-text-field
                          id="startDate"
                          placeholder="Input Start Date"
                          single-line
                          append-icon="event"
                          dense
                          outlined
                          readonly
                          v-on="on"
                          :error-messages="errors"
                          v-model="form.agreement_information.date_start"
                          :disabled="isDisabled"
                          :filled="isDisabled"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="form.agreement_information.date_start"
                      @input="menuAgreementStartDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    v-model="menuAgreementEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    nudge-bottom="-10"
                    min-width="290px"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        slim
                        vid="agreement_end_date"
                        name="End Date"
                        :rules="rules.agreementEndDate"
                        v-slot="{ errors }"
                      >
                        <label
                          for="endDate"
                          class="fs-12 font-weight-regular mb-1"
                        >
                          End Date
                        </label>
                        <v-text-field
                          id="endDate"
                          placeholder="Input End Date"
                          single-line
                          append-icon="event"
                          dense
                          outlined
                          readonly
                          v-on="on"
                          :error-messages="errors"
                          v-model="form.agreement_information.date_end"
                          :disabled="isDisabled"
                          :filled="isDisabled"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="form.agreement_information.date_end"
                      :min="form.agreement_information.date_start"
                      @input="menuAgreementEndDate = false"
                      no-title
                    >
                    </v-date-picker>
                  </v-menu>

                  <ValidationProvider
                    slim
                    name="Amount of Support"
                    :rules="rules.agreementAmountSupport"
                    v-slot="{ errors }"
                  >
                    <label
                      for="amountOfSupport2"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Amount of Support
                    </label>
                    <v-currency-field
                      id="amountOfSupport2"
                      placeholder="Input Amount of Support"
                      single-line
                      v-model="form.agreement_information.amount_of_support"
                      :error-messages="errors"
                      disabled
                      filled
                    />
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Payment"
                    :rules="rules.agreementPayment"
                    v-slot="{ errors }"
                  >
                    <label
                      for="paymentType"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Payment
                    </label>
                    <v-select
                      id="paymentType"
                      placeholder="Select Payment"
                      single-line
                      :items="paymentTypes"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="form.agreement_information.payment_type"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      @change="onPaymentTypeChanged"
                    ></v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Payment Stage"
                    :rules="{
                      payment_stage: {
                        amountOfSupport:
                          form.general_information.amount_of_support
                      }
                    }"
                    v-slot="{ errors }"
                  >
                    <payment-stage-field
                      v-model="payments"
                      :payment-type="form.agreement_information.payment_type"
                      :disabled="isDisabled"
                      :amount-of-support="
                        form.general_information.amount_of_support
                      "
                      :errors="errors"
                    />
                    <div class="error--text my-2 fs-12">{{ errors[0] }}</div>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              Event Information
            </v-card-title>
            <v-card-text class="black--text pt-4">
              <v-row>
                <v-col offset="0" offset-sm="3" cols="6">
                  <ValidationProvider
                    slim
                    name="Total Amount"
                    :rules="{
                      required: true,
                      total_amount: {
                        target: form.general_information.amount_of_support
                      }
                    }"
                    v-slot="{ errors }"
                  >
                    <label
                      for="totalAmount"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Total Amount
                    </label>
                    <v-currency-field
                      id="totalAmount"
                      placeholder="Total Amount"
                      :value="form.event_information.total_amount"
                      single-line
                      hide-details
                      readonly
                      filled
                    ></v-currency-field>
                    <div class="error--text fs-12" v-if="errors.length">
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row no-gutters align="center" justify="space-between">
                <v-col cols="10">
                  <v-tabs hide-slider v-model="tab" class="tab-events">
                    <v-tab v-for="(item, index) in events" :key="index">
                      <span class="text-capitalize">Event {{ index + 1 }}</span>
                      <v-btn
                        v-if="events.length > 1 && !isDisabled"
                        class="ml-2"
                        :color="tab === index ? 'error' : ''"
                        @click="removeEvent(index)"
                        icon
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-tab>
                  </v-tabs>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    v-if="!isDisabled"
                    color="success"
                    fab
                    right
                    rounded
                    x-small
                    depressed
                    @click="addEvent"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider class="primary" style="height: 2px;" />

              <v-tabs-items v-model="tab">
                <v-tab-item
                  v-for="(event, eventIndex) in events"
                  :key="eventIndex"
                  @input="onEventInput(event)"
                >
                  <v-card flat>
                    <v-card-text class="black--text pt-4 pb-0">
                      <v-row>
                        <v-col offset="0" offset-sm="3" cols="12" sm="6">
                          <label
                            :for="`purposeOfEvent${eventIndex}`"
                            class="fs-12 font-weight-regular mb-2 d-block"
                          >
                            Purpose of Event
                          </label>
                          <v-row dense>
                            <v-col>
                              <ValidationProvider
                                slim
                                name="Purpose peserta"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="event.purpose_with.peserta"
                                  label="{PESERTA}"
                                  placeholder=" "
                                  :error-messages="errors"
                                  :disabled="isDisabled"
                                  @input="
                                    onPurposeWithChanged(
                                      $event,
                                      event,
                                      eventIndex
                                    )
                                  "
                                  hide-details
                                  outlined
                                />
                              </ValidationProvider>
                            </v-col>
                            <v-col>
                              <ValidationProvider
                                slim
                                name="Purpose bidang"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="event.purpose_with.bidang"
                                  label="{BIDANG/SUBJECT PENGETAHUAN}"
                                  placeholder=" "
                                  :error-messages="errors"
                                  :disabled="isDisabled"
                                  hide-details
                                  outlined
                                  @input="
                                    onPurposeWithChanged(
                                      $event,
                                      event,
                                      eventIndex
                                    )
                                  "
                                />
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col>
                              <ValidationProvider
                                slim
                                name="Purpose participant"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="event.purpose_with.participant"
                                  label="{PARTICIPANTS}"
                                  placeholder=" "
                                  :error-messages="errors"
                                  :disabled="isDisabled"
                                  hide-details
                                  outlined
                                  @input="
                                    onPurposeWithChanged(
                                      $event,
                                      event,
                                      eventIndex
                                    )
                                  "
                                />
                              </ValidationProvider>
                            </v-col>
                            <v-col>
                              <ValidationProvider
                                slim
                                name="Purpose area"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-text-field
                                  v-model="event.purpose_with.subject"
                                  label="{AREA/SUBJECT OF KNOWLEGDE}"
                                  placeholder=" "
                                  :error-messages="errors"
                                  :disabled="isDisabled"
                                  hide-details
                                  outlined
                                  @input="
                                    onPurposeWithChanged(
                                      $event,
                                      event,
                                      eventIndex
                                    )
                                  "
                                />
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <ValidationProvider
                            slim
                            name="Purpose of Event"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-textarea
                              :id="`purposeOfEvent${eventIndex}`"
                              v-model="event.purpose"
                              :error-messages="errors"
                              class="mt-3"
                              single-line
                              disabled
                              outlined
                              filled
                              dense
                            ></v-textarea>
                          </ValidationProvider>

                          <ValidationProvider
                            slim
                            name="Activities of Event"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label
                              :for="`actOfEvent${eventIndex}`"
                              class="fs-12 font-weight-regular mb-1"
                            >
                              Activities of Event
                            </label>
                            <v-autocomplete
                              :id="`actOfEvent${eventIndex}`"
                              placeholder="Activities of Event"
                              single-line
                              v-model="event.activities"
                              :disabled="isDisabled"
                              :filled="isDisabled"
                              dense
                              outlined
                              :error-messages="errors"
                              :items="activities"
                            ></v-autocomplete>
                          </ValidationProvider>

                          <ValidationProvider
                            slim
                            name="Name of Event"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label
                              :for="`nameOfEvent${eventIndex}`"
                              class="fs-12 font-weight-regular mb-1"
                            >
                              Name of Event
                            </label>
                            <v-text-field
                              :id="`nameOfEvent${eventIndex}`"
                              placeholder="Name of Event"
                              single-line
                              v-model="event.name"
                              :disabled="isDisabled"
                              :filled="isDisabled"
                              dense
                              outlined
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>

                          <ValidationProvider
                            slim
                            name="Venue of Event"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label
                              :for="`venueOfEvent${eventIndex}`"
                              class="fs-12 font-weight-regular mb-1"
                            >
                              Venue of Event
                            </label>
                            <v-text-field
                              :id="`venueOfEvent${eventIndex}`"
                              placeholder="Venue of Event"
                              single-line
                              v-model="event.venue"
                              :disabled="isDisabled"
                              :filled="isDisabled"
                              dense
                              outlined
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>
                          <v-row>
                            <v-col>
                              <v-menu
                                v-model="event.menuStartDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                nudge-bottom="-10"
                                min-width="290px"
                                offset-y
                              >
                                <template v-slot:activator="{ on }">
                                  <ValidationProvider
                                    slim
                                    name="Start Date"
                                    :rules="
                                      `required|date_before:event_end_date${eventIndex}`
                                    "
                                    v-slot="{ errors }"
                                  >
                                    <label
                                      :for="`startDate${eventIndex}`"
                                      class="fs-12 font-weight-regular mb-1"
                                    >
                                      Start Date
                                    </label>
                                    <v-text-field
                                      :id="`startDate${eventIndex}`"
                                      v-model="event.date_start"
                                      :disabled="isDisabled"
                                      :filled="isDisabled"
                                      placeholder="Start Date"
                                      single-line
                                      append-icon="event"
                                      dense
                                      outlined
                                      readonly
                                      v-on="on"
                                      :error-messages="errors"
                                    ></v-text-field>
                                  </ValidationProvider>
                                </template>
                                <v-date-picker
                                  v-model="event.date_start"
                                  :disabled="isDisabled"
                                  :filled="isDisabled"
                                  :min="form.agreement_information.date_start"
                                  :max="form.agreement_information.date_end"
                                  @input="event.menuStartDate = false"
                                  no-title
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col>
                              <v-menu
                                v-model="event.menuEndDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                nudge-bottom="-10"
                                min-width="290px"
                                offset-y
                              >
                                <template v-slot:activator="{ on }">
                                  <ValidationProvider
                                    slim
                                    name="End Date"
                                    rules="required"
                                    v-slot="{ errors }"
                                    :vid="`event_end_date${eventIndex}`"
                                  >
                                    <label
                                      :for="`endDate${eventIndex}`"
                                      class="fs-12 font-weight-regular mb-1"
                                    >
                                      End Date
                                    </label>
                                    <v-text-field
                                      :id="`endDate${eventIndex}`"
                                      v-model="event.date_end"
                                      :disabled="isDisabled"
                                      :filled="isDisabled"
                                      placeholder="End Date"
                                      single-line
                                      append-icon="event"
                                      dense
                                      outlined
                                      readonly
                                      v-on="on"
                                      :error-messages="errors"
                                    ></v-text-field>
                                  </ValidationProvider>
                                </template>
                                <v-date-picker
                                  v-model="event.date_end"
                                  :disabled="isDisabled"
                                  :filled="isDisabled"
                                  :min="event.date_start"
                                  :max="form.agreement_information.date_end"
                                  @input="event.menuEndDate = false"
                                  no-title
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>

                          <ValidationProvider
                            slim
                            name="Frequency of Activity"
                            rules="required|min_value:1"
                            v-slot="{ errors }"
                          >
                            <label
                              :for="`freqOfActivity${eventIndex}`"
                              class="fs-12 font-weight-regular mb-1"
                            >
                              Frequency of Activity
                            </label>
                            <v-text-field
                              :id="`freqOfActivity${eventIndex}`"
                              placeholder="Frequency of Activity"
                              single-line
                              v-model="event.frequency"
                              :disabled="isDisabled"
                              :filled="isDisabled"
                              type="number"
                              dense
                              outlined
                              :error-messages="errors"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Item</th>
                              <th class="text-left">Price</th>
                              <th class="text-left">Quantity</th>
                              <th class="text-left">Frequency</th>
                              <th class="text-left">Amount</th>
                              <th class="text-left"></th>
                              <th class="text-left"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, eventItemIndex) in event.items"
                              :key="eventItemIndex"
                            >
                              <td>
                                <ValidationProvider
                                  slim
                                  name="Item"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    placeholder="Item"
                                    single-line
                                    v-model="item.item"
                                    :disabled="isDisabled"
                                    :filled="isDisabled"
                                    dense
                                    outlined
                                    hide-details
                                    :error-messages="errors"
                                  ></v-text-field>
                                </ValidationProvider>
                              </td>
                              <td>
                                <ValidationProvider
                                  slim
                                  name="Price"
                                  rules="required|min_value:1"
                                  v-slot="{ errors }"
                                >
                                  <v-currency-field
                                    placeholder="Price"
                                    single-line
                                    v-model="item.price"
                                    :disabled="isDisabled"
                                    :filled="isDisabled"
                                    :error-messages="errors"
                                    hide-details
                                  />
                                </ValidationProvider>
                              </td>
                              <td>
                                <ValidationProvider
                                  slim
                                  name="Quantity"
                                  rules="required|min_value:1"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    placeholder="Quantity"
                                    single-line
                                    v-model="item.quantity"
                                    :disabled="isDisabled"
                                    :filled="isDisabled"
                                    type="number"
                                    dense
                                    outlined
                                    hide-details
                                    :error-messages="errors"
                                  ></v-text-field>
                                </ValidationProvider>
                              </td>
                              <td>
                                <ValidationProvider
                                  slim
                                  name="Frequency"
                                  rules="required|min_value:1"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    placeholder="Frequency"
                                    single-line
                                    v-model="item.frequency"
                                    :disabled="isDisabled"
                                    :filled="isDisabled"
                                    type="number"
                                    dense
                                    outlined
                                    hide-details
                                    :error-messages="errors"
                                  ></v-text-field>
                                </ValidationProvider>
                              </td>
                              <td>
                                <ValidationProvider
                                  slim
                                  name="Amount"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-currency-field
                                    placeholder="Amount"
                                    single-line
                                    :value="item.amount"
                                    :error-messages="errors"
                                    hide-details
                                    readonly
                                    filled
                                  />
                                </ValidationProvider>
                              </td>
                              <td class="px-2">
                                <v-btn
                                  v-if="event.items.length > 1 && !isDisabled"
                                  outlined
                                  small
                                  color="error"
                                  icon
                                  @click="
                                    removeEventItem(event, eventItemIndex)
                                  "
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </td>
                              <td class="px-2">
                                <v-btn
                                  v-if="eventItemIndex === 0 && !isDisabled"
                                  outlined
                                  small
                                  icon
                                  color="success"
                                  @click="addEventItem(event)"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>

                      <v-row>
                        <v-col offset="0" offset-sm="3" cols="6">
                          <ValidationProvider
                            slim
                            name="Total Amount"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <label
                              for="totalAmountEvent"
                              class="fs-12 font-weight-regular mb-1"
                            >
                              Total Amount
                            </label>
                            <v-currency-field
                              id="totalAmountEvent"
                              placeholder="Total Amount"
                              single-line
                              :error-messages="errors"
                              :value="event.items_total_amount"
                              readonly
                              filled
                            ></v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>

          <v-card :loading="uploading" class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              Supporting Documents
            </v-card-title>
            <v-card-text class="black--text pt-4 pb-0">
              <v-row dense align="center">
                <v-col
                  offset="0"
                  offset-sm="2"
                  offset-md="3"
                  cols="12"
                  sm="8"
                  md="6"
                >
                  <ValidationProvider
                    slim
                    name="Invoice"
                    :rules="rules.supDocInvoice"
                    v-slot="{ errors }"
                  >
                    <label for="invoice" class="fs-12 font-weight-regular mb-1">
                      Invoice
                    </label>
                    <supporting-document-link
                      v-if="detail && isDisabled"
                      :detail="detail"
                      name="invoice"
                    />
                    <v-file-input
                      v-else
                      id="invoice"
                      placeholder="Invoice"
                      single-line
                      prepend-icon=""
                      append-icon="mdi-attachment"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="temp_documents.invoice.file"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-file-input>
                    <div
                      class="mb-6"
                      v-if="isViewDocsLink && !temp_documents.invoice.file"
                    >
                      <supporting-document-link
                        :detail="detail"
                        name="invoice"
                        small
                      />
                    </div>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Proposal"
                    :rules="rules.supDocProposal"
                    v-slot="{ errors }"
                  >
                    <label
                      for="proposal"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Proposal
                    </label>
                    <supporting-document-link
                      v-if="detail && isDisabled"
                      :detail="detail"
                      name="proposal"
                    />
                    <v-file-input
                      v-else
                      id="proposal"
                      placeholder="Proposal"
                      single-line
                      prepend-icon=""
                      append-icon="mdi-attachment"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="temp_documents.proposal.file"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-file-input>
                    <div
                      class="mb-6"
                      v-if="isViewDocsLink && !temp_documents.proposal.file"
                    >
                      <supporting-document-link
                        :detail="detail"
                        name="proposal"
                        small
                      />
                    </div>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="MOU"
                    :rules="rules.supDocMOU"
                    v-slot="{ errors }"
                  >
                    <label for="mou" class="fs-12 font-weight-regular mb-1">
                      MOU
                    </label>
                    <supporting-document-link
                      v-if="detail && isDisabled"
                      :detail="detail"
                      name="mou"
                    />
                    <v-file-input
                      v-else
                      id="mou"
                      placeholder="MOU"
                      single-line
                      prepend-icon=""
                      append-icon="mdi-attachment"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="temp_documents.mou.file"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-file-input>
                    <div
                      class="mb-6"
                      v-if="isViewDocsLink && !temp_documents.mou.file"
                    >
                      <supporting-document-link
                        :detail="detail"
                        name="mou"
                        small
                      />
                    </div>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Summary of Prevalidation"
                    :rules="rules.supDocSoP"
                    v-slot="{ errors }"
                  >
                    <label
                      for="sumOfPrevalidation"
                      class="fs-12 font-weight-regular mb-1"
                    >
                      Summary of Prevalidation
                    </label>
                    <supporting-document-link
                      v-if="detail && isDisabled"
                      :detail="detail"
                      name="summary_of_prevalidation"
                    />
                    <v-file-input
                      v-else
                      id="sumOfPrevalidation"
                      placeholder="Summary of Prevalidation"
                      single-line
                      prepend-icon=""
                      append-icon="mdi-attachment"
                      dense
                      outlined
                      :error-messages="errors"
                      v-model="temp_documents.summary_of_prevalidation.file"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                    ></v-file-input>
                    <div
                      class="mb-6"
                      v-if="
                        isViewDocsLink &&
                          !temp_documents.summary_of_prevalidation.file
                      "
                    >
                      <supporting-document-link
                        :detail="detail"
                        name="summary_of_prevalidation"
                        small
                      />
                    </div>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mb-4 rounded-10 elevation-card">
            <v-card-title
              class="font-weight-700 fs-14 lh-14 primary pa-4 white--text"
            >
              Signature & Information Of First Party
            </v-card-title>
            <v-card-text class="black--text pt-4 pb-0">
              <v-row dense align="center">
                <v-col
                  offset="0"
                  offset-sm="2"
                  offset-md="3"
                  cols="12"
                  sm="8"
                  md="6"
                >
                  <ValidationProvider
                    slim
                    name="Region Address"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      for="regionAddress"
                      class="mb-1 fs-12 font-weight-regular"
                    >
                      Region Address
                    </label>
                    <v-textarea
                      id="regionAddress"
                      placeholder="Input Region Address"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      v-model="
                        form.signature_information_of_first_party.region_address
                      "
                    ></v-textarea>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Phone Number"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      for="phoneNumber"
                      class="mb-1 fs-12 font-weight-regular"
                    >
                      Phone Number
                    </label>
                    <v-text-field
                      id="phoneNumber"
                      placeholder="Input Phone Number"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      v-model="
                        form.signature_information_of_first_party.phone_number
                      "
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Fax Number"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      for="faxNumber"
                      class="mb-1 fs-12 font-weight-regular"
                    >
                      Fax Number
                    </label>
                    <v-text-field
                      id="faxNumber"
                      placeholder="Input Fax Number"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      v-model="
                        form.signature_information_of_first_party.fax_number
                      "
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="Email"
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <label for="email2" class="mb-1 fs-12 font-weight-regular">
                      Email
                    </label>
                    <v-text-field
                      id="email2"
                      placeholder="Input Email"
                      single-line
                      type="email"
                      dense
                      outlined
                      :error-messages="errors"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      v-model="form.signature_information_of_first_party.email"
                    ></v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    name="PIC Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label
                      for="picNumber"
                      class="mb-1 fs-12 font-weight-regular"
                    >
                      PIC Name
                    </label>
                    <v-text-field
                      id="picNumber"
                      placeholder="Input PIC Name"
                      single-line
                      dense
                      outlined
                      :error-messages="errors"
                      :disabled="isDisabled"
                      :filled="isDisabled"
                      v-model="
                        form.signature_information_of_first_party.pic_name
                      "
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-row v-if="!isDisabled" no-gutters align="center" class="my-4">
            <v-spacer></v-spacer>
            <v-btn
              @click="saveAsDraft"
              :disabled="uploading || loading || submitting"
              class="btn-medium mr-4"
            >
              <v-icon class="mr-2">mdi-content-save</v-icon>
              Save as Draft
            </v-btn>
            <v-btn
              type="submit"
              color="menuActive"
              class="btn-medium"
              :loading="loading || submitting"
              :disabled="invalid || uploading"
              :dark="!invalid && !uploading"
            >
              <v-icon class="mr-2">mdi-send</v-icon>
              Send
            </v-btn>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import VCurrencyField from '@/components/VCurrencyField';
import Swal from 'sweetalert2';
import SupportingDocumentLink from '@/components/SSHCF/SupportingDocumentLink';
import PaymentStageField from '@/components/SSHCF/PaymentStageField';
import GenerateMOUMixin from '@/mixins/SSHCF/GenerateMOUMixin';
import {
  formatFormRequestData,
  mapFormRequest
} from '@/utils/FormRequestHelper';
import { getLocalUser } from '@/utils/helpers';

const createdAt = moment().format('YYYY-MM-DD');

export default {
  name: 'FormRequest',
  mixins: [GenerateMOUMixin],
  props: {
    id: {}
  },
  components: {
    PaymentStageField,
    SupportingDocumentLink,
    VCurrencyField
  },
  data() {
    return {
      ioWarning: '',
      detail: null,
      minDate: moment().toISOString(),
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'Rp',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      },
      paymentType: 1,
      tab: null,
      events: [
        {
          menuStartDate: false,
          menuEndDate: false,
          purpose_with: {
            peserta: '',
            participant: '',
            bidang: '',
            subject: ''
          },
          purpose:
            'Untuk meningkatkan kesadaran dan pengetahuan dari {peserta} di bidang {bidang/subjek pengetahuan} / to increase awareness and knowledge of {participants} in the field of {area/subject of knowledge}',
          activities: '',
          name: '',
          venue: '',
          date_start: null,
          date_end: null,
          frequency: 0,
          items_total_amount: 0,
          items: [
            {
              item: '',
              price: 0,
              quantity: 0,
              frequency: 0,
              amount: 0
            }
          ]
        }
      ],
      loading: false,
      uploading: false,
      date: null,
      menu: false,
      menuEventStartDate: false,
      menuEventEndDate: false,
      menuAgreementStartDate: false,
      menuAgreementEndDate: false,
      paymentAmount: 0,
      payments: [
        {
          percentage: 100,
          amount: 0
        }
      ],
      temp_documents: {
        invoice: {
          file: null
        },
        proposal: {
          file: null
        },
        mou: {
          file: null
        },
        summary_of_prevalidation: {
          file: null
        }
      },
      form: {
        requestor: {
          region: '',
          district: '',
          district_manager: ''
        },
        general_information: {
          created_date: createdAt,
          preval_number: '',
          po_number: 'Non PO Activity',
          gl_account: '811112',
          cost_center: '400455',
          io_number: '',
          // io_description: '',
          amount_of_support: 0
        },
        first_party_information: {
          company_name: '',
          company_address: '',
          name_of_signatory: '',
          title_of_signatory: ''
        },
        second_party_information: {
          hospital_name: '',
          hospital_description: '',
          hospital_address: '',
          hospital_city: '',
          hospital_telephone: '',
          hospital_fax: '',
          hospital_email: '',
          vendor_code: '',
          vendor_name: '',
          bank_name: '',
          bank_branch: '',
          bank_account_number: '',
          signatory_name: '',
          signatory_title: '',
          remarks: ''
        },
        agreement_information: {
          date_start: '',
          date_end: '',
          amount_of_support: 0,
          payment_type: '',
          payments: []
        },
        event_information: {
          total_amount: 0,
          events: this.events
        },
        supporting_documents: {
          invoice: {
            name: null,
            url: ''
          },
          proposal: {
            name: null,
            url: ''
          },
          mou: {
            name: null,
            url: ''
          },
          summary_of_prevalidation: {
            name: null,
            url: ''
          }
        },
        signature_information_of_first_party: {
          region_address: '',
          phone_number: '',
          fax_number: '',
          email: '',
          pic_name: ''
        }
      },
      activities: [
        {
          text: 'Seminar/Seminar'
        },
        {
          text: 'Training/Pelatihan'
        },
        {
          text: 'Education/Edukasi'
        },
        {
          text:
            'Working visit to production site/Kunjungan kerja ke fasilitas produksi'
        }
      ],
      generating: false,
      submitting: false,
      isRevise: false
    };
  },
  computed: {
    ...mapState('sshcf', [
      'formRequest',
      'regions',
      'districts',
      'districtManagers',
      'companies',
      'hospitals',
      'vendors',
      'ioNumbers'
    ]),
    isViewDocsLink() {
      if (!this.detail) return false;

      return this.isEditing || this.isRevise;
    },
    paymentTypes() {
      const types = [
        {
          text: 'One payment',
          value: 1
        }
      ];
      if (this.isMoreThan500) {
        types.push({
          text: 'More than one payment',
          value: 2
        });
      }
      return types;
    },
    isMoreThan500() {
      return this.form.general_information.amount_of_support >= 500000000;
    },
    breadcrumbs() {
      return [
        {
          text: 'SSHCF',
          to: '/sshcf/'
        },
        {
          text: this.title,
          disabled: true
        }
      ];
    },
    title() {
      if (this.isEditing) return 'Edit Form Request';

      return this.id ? 'Detail Form Request' : 'Add New Request';
    },
    hasRevision() {
      return this.formRequest?.revision;
    },
    subtitle() {
      return this.id
        ? this.formRequest?.hcf_code || 'Detail Form Request'
        : 'Form Request';
    },
    isNotOwner() {
      const user = getLocalUser();
      return this.formRequest?.created_by !== user?.email;
    },
    isDisabled() {
      const isNotDraft = this.formRequest?.local_status !== 'Draft';
      return (
        (this.isNotOwner && this.isEditing) ||
        (this.id && isNotDraft && !this.isRevise)
      );
    },
    isEditing() {
      return !!this.id && this.formRequest?.local_status === 'Draft';
    },
    canRevise() {
      return (
        this.id && this.formRequest?.local_status?.toLowerCase() === 'rejected'
      );
    },
    rules() {
      const rules = {
        region: 'required',
        district: 'required',
        district_manager: 'required',
        createdDate: 'required',
        ioNumber: 'required',
        amountOfSupport: 'required|min_value:1',
        companyName: 'required',
        companyAddress: 'required',
        second_party_information: 'required',
        agreementStartDate: 'required|date_before:agreement_end_date',
        agreementEndDate: 'required',

        agreementAmountSupport: 'required',
        agreementPayment: 'required',
        eventStartDate: 'required',
        eventEndDate: 'required',
        supDocInvoice: 'required',
        supDocProposal: 'required',
        supDocMOU: 'required',
        supDocSoP: 'required'
      };
      if (this.isEditing || this.isRevise) {
        rules.supDocInvoice = undefined;
        rules.supDocProposal = undefined;
        rules.supDocMOU = undefined;
        rules.supDocSoP = undefined;
      }
      return rules;
    },
    districtManagerItems() {
      const { id, d_manager_name: name } = this.districtManagers;

      if (!id || !name) return [];

      return [
        {
          id,
          name
        }
      ];
    },
    hospitalDescs() {
      return [
        {
          value: 'Hospital/Rumah Sakit',
          text: 'Hospital/Rumah Sakit'
        },
        {
          value: 'Limited Liability Company/Perseroan Terbatas',
          text: 'Limited Liability Company/Perseroan Terbatas'
        },
        {
          value: 'Foundation/Yayasan',
          text: 'Foundation/Yayasan'
        }
      ];
    },
    eventTotalAmount() {
      return this.events.reduce((previousValue, currentValue) => {
        return (previousValue += currentValue.items_total_amount);
      }, 0);
    }
  },
  watch: {
    'form.requestor.region'(name) {
      if (!name) return;

      const region = this.regions.find(item => item.r_name === name);

      if (region) {
        this.form.signature_information_of_first_party.region_address =
          region.r_office_address;
        this.form.signature_information_of_first_party.phone_number =
          region.r_office_phone_number;
        this.form.signature_information_of_first_party.fax_number =
          region.r_office_fax_number;
        this.form.signature_information_of_first_party.email =
          region.r_manager_email;
        this.form.signature_information_of_first_party.pic_name =
          region.r_manager_name;

        if (!this.id) {
          this.form.requestor.district_manager = '';
        }

        this.fetchDistrictsByRegion(region.id);
      }
    },
    async 'form.requestor.district'(name) {
      if (!name) return;

      const district = this.districts.find(item => item.d_name === name);

      if (district) {
        this.form.requestor.district_manager = district.d_manager_name;
      }
    },
    'form.first_party_information.company_name'(company) {
      if (company) {
        this.form.first_party_information.company_address = `${company.c_address}, Kelurahan ${company.c_village}, Kecamatan ${company.c_district}, Kota ${company.c_city} ${company.c_postal_code} - ${company.c_country}`;
      }
    },
    'form.general_information.amount_of_support'(val) {
      if (!val) return;

      this.setAmountSupport(val);
    },
    'form.second_party_information.hospital_name'(hospital) {
      if (hospital) {
        this.form.second_party_information.hospital_address =
          hospital.h_address;
        this.form.second_party_information.hospital_city = hospital.h_city;

        // const vendor = hospital.vendor;

        // if (vendor) {
        //   this.form.second_party_information.vendor_code = vendor;
        // } else {
        //   this.form.second_party_information.vendor_code = null;
        // }
      }
    },
    'form.second_party_information.vendor_code'(vendor) {
      if (!this.id) {
        if (vendor && vendor.hospital) {
          this.form.second_party_information.hospital_name = vendor.hospital;
        }
      }

      if (vendor) {
        this.form.second_party_information.vendor_name = vendor.v_name;
        this.form.second_party_information.bank_name = vendor.v_bank_name;
        this.form.second_party_information.bank_branch = vendor.v_bank_branch;
        this.form.second_party_information.bank_account_number =
          vendor.v_bank_account;
      } else {
        this.form.second_party_information.vendor_name = '';
        this.form.second_party_information.bank_name = '';
        this.form.second_party_information.bank_branch = '';
        this.form.second_party_information.bank_account_number = '';
      }
    },
    'form.general_information.io_number'(val) {
      if (!this.ioNumbers.includes(val)) {
        this.ioWarning = 'IO Number is not valid';
      } else {
        this.ioWarning = '';
      }
      // this.form.general_information.io_description = val.io_desc;
    }
  },
  async mounted() {
    this.loading = true;
    this.fetchRegions();
    this.fetchCompanies();
    this.fetchHospitals();
    this.fetchVendors();
    this.fetchIONumber();

    if (this.id) {
      this.fetchDetail();
    } else {
      this.loading = false;
    }
  },
  methods: {
    onAmountOfSupportChanged() {
      if (this.id) return;

      this.$nextTick(() => {
        this.onPaymentTypeChanged(this.form.agreement_information.payment_type);
      });
    },
    onPaymentTypeChanged(type) {
      if (type === 1) {
        this.payments = [
          {
            percentage: 100,
            amount: this.calcAmount(100)
          }
        ];
      } else if (type === 2) {
        this.payments = [
          {
            percentage: 50,
            amount: this.calcAmount(50)
          },
          {
            percentage: 50,
            amount: this.calcAmount(50)
          }
        ];
      }
    },
    calcAmount(percentage) {
      return Math.round(
        (percentage / 100) * this.form.general_information.amount_of_support
      );
    },
    revise() {
      this.isRevise = !this.isRevise;
    },
    fetchIONumber() {
      return this.$store.dispatch('sshcf/getIONumber');
    },
    resetIONumber() {
      this.form.general_information.io_number = this.ioNumbers.find(
        item => item.io_number === this.formRequest?.io_number
      );
    },
    async fetchDetail() {
      this.loading = true;
      const res = await this.$store.dispatch(
        'sshcf/getFormRequestDetail',
        this.id
      );
      this.loading = false;
      const data = res.data.result;

      this.detail = data;

      const company = this.companies.find(
        item => item.c_name === data.company_name
      );
      const hospital = this.hospitals.find(
        item => item.h_name === data.hospital
      );
      const vendor = this.vendors.find(
        vendor => +vendor.v_code === +data.vendor_code
      );
      const ioNumber = this.ioNumbers.find(
        item => item.io_number === data.io_number
      );
      const { form, events, payments } = mapFormRequest(
        data,
        company,
        hospital,
        vendor,
        ioNumber
      );

      this.payments = payments;
      this.events = events;
      this.form = form;
    },
    updateEventAmount(eventIndex, eventItemIndex) {
      const event = { ...this.events[eventIndex] };
      const eventItem = { ...event.items[eventItemIndex] };
      const amount = +eventItem.price * +eventItem.quantity;

      event.items[eventItemIndex].amount = amount;
    },
    fetchRegions() {
      return this.$store.dispatch('sshcf/getRegions', {
        paginate: false
      });
    },
    fetchCompanies() {
      return this.$store.dispatch('sshcf/getCompanies', {
        paginate: false
      });
    },
    fetchHospitals() {
      return this.$store.dispatch('sshcf/getHospitals', {
        paginate: false
      });
    },
    fetchVendors() {
      return this.$store.dispatch('sshcf/getVendors', {
        paginate: false
      });
    },
    fetchDistrictsManager(districtId) {
      return this.$store.dispatch('sshcf/getDistrictsManager', districtId);
    },
    fetchDistrictsByRegion(regionId) {
      return this.$store.dispatch('sshcf/getDistrictsByRegion', regionId);
    },
    addEvent() {
      this.events.push({
        menuStartDate: false,
        menuEndDate: false,
        purpose_with: {
          peserta: '',
          participant: '',
          bidang: '',
          subject: ''
        },
        purpose:
          'Untuk meningkatkan kesadaran dan pengetahuan dari {peserta} di bidang {bidang/subjek pengetahuan} / to increase awareness and knowledge of {participants} in the field of {area/subject of knowledge}',
        activities: '',
        name: '',
        venue: '',
        date_start: null,
        date_end: null,
        frequency: 0,
        items_total_amount: 0,
        items: [
          {
            item: '',
            price: 0,
            quantity: 0,
            frequency: 0,
            amount: 0
          }
        ]
      });
      this.tab = this.events.length - 1;
    },
    removeEvent(index) {
      this.events.splice(index, 1);
    },
    addEventItem(event) {
      event.items.push({
        item: '',
        price: 0,
        quantity: '',
        frequency: 0,
        amount: 0
      });
    },
    removeEventItem(event, index) {
      event.items.splice(index, 1);
    },
    async uploadFile(objectKey) {
      const tempDocs = this.temp_documents;

      if (!tempDocs[objectKey].file) return false;

      const supportDocs = this.form.supporting_documents;
      let formData = new FormData();
      formData.append('file', tempDocs[objectKey].file);
      await this.$store
        .dispatch('sshcf/uploadFile', formData)
        .then(data => {
          if (data.code === 200) {
            supportDocs[objectKey].name = tempDocs[objectKey].file.name;
            supportDocs[objectKey].url = data.data;
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    async setupUploadFile() {
      const supportDocs = this.form.supporting_documents;
      for (let key in supportDocs) {
        await this.uploadFile(key);
      }
      return Object.keys(supportDocs).every(key => supportDocs[key].url !== '');
    },
    handleResponse(res) {
      if (res.code === 200) {
        this.$store.dispatch('sshcf/syncData', 'form_request');
        Swal.fire('Success!', res.message.text_en, 'success');
        this.$router.push({
          name: 'sshcf_requests'
        });
      } else {
        Swal.fire('Failed!', res.message.text_en, 'error');
      }
    },
    async publishFormRequest() {
      this.uploading = true;
      await this.setupUploadFile();
      this.uploading = false;

      this.submitting = true;
      const res = await this.$store.dispatch('sshcf/publishFormRequest', {
        formId: this.id,
        data: this.getFormData()
      });
      this.submitting = false;
      this.handleResponse(res);
    },
    async updateFormRequest() {
      this.uploading = true;
      await this.setupUploadFile();
      this.uploading = false;

      this.submitting = true;
      const res = await this.$store.dispatch('sshcf/updateFormRequest', {
        formId: this.id,
        data: this.getFormData()
      });
      this.submitting = false;
      this.handleResponse(res);
    },
    async createFormRequest(data) {
      this.submitting = true;
      const res = await this.$store.dispatch('sshcf/createFormRequests', data);
      this.submitting = false;
      this.handleResponse(res);
    },
    async saveAsDraft() {
      const isValid = await this.$refs.form.validate();

      if (isValid) {
        if (this.isEditing) {
          this.updateFormRequest();
        } else {
          this.submitAsDraft();
        }
      }
    },
    async submitAsDraft() {
      this.uploading = true;
      const uploadFileSuccess = await this.setupUploadFile();
      this.uploading = false;

      if (uploadFileSuccess) {
        this.submitting = true;
        const res = await this.$store.dispatch(
          'sshcf/saveAsDraft',
          this.getFormData()
        );
        this.submitting = false;
        this.handleResponse(res);
      }
    },
    getEvents() {
      return JSON.parse(JSON.stringify(this.events)).map(item => {
        delete item.menuStartDate;
        delete item.menuEndDate;
        return item;
      });
    },
    getFormData() {
      const events = this.getEvents();
      const payments = this.payments.map(item => ({
        percent: item.percentage,
        amount: item.amount
      }));

      return formatFormRequestData({
        form: this.form,
        events,
        payments,
        isEditing: this.isEditing,
        revision: this.isRevise ? this.formRequest?.hcf_code : null
      });
    },
    async onSubmit() {
      if (this.isEditing) {
        this.publishFormRequest();
      } else {
        this.storeFormRequest();
      }
    },
    async storeFormRequest() {
      this.uploading = true;
      const uploadFileSuccess = await this.setupUploadFile();
      this.uploading = false;

      if (uploadFileSuccess) {
        this.loading = true;
        await this.createFormRequest(this.getFormData());
        this.loading = false;
      }
    },
    onEventInput(item) {
      item.items.forEach(
        elm => (elm.amount = elm.price * elm.quantity * elm.frequency)
      );
      item.items_total_amount =
        item.frequency * this.sumNumber(item.items, 'amount');
      this.form.event_information.total_amount = this.sumNumber(
        this.events,
        'items_total_amount'
      );
    },
    sumNumber(items, key) {
      if (items) {
        return items.reduce(function(a, b) {
          return a + b[key];
        }, 0);
      }
    },
    setAmountSupport(value) {
      if (value > 200000000) {
        this.form.first_party_information.name_of_signatory =
          'Eric Goncalves Arantes Salviano';
        this.form.first_party_information.title_of_signatory =
          'HN Director/Direktur HN';
      } else {
        this.form.first_party_information.name_of_signatory =
          'Ashari Fitriyansyah';
        this.form.first_party_information.title_of_signatory =
          'HN Solution Director/Direktur HN Solution';
      }
      this.paymentAmount = value;
      this.form.agreement_information.amount_of_support = value;
    },
    onVendorCodeChanged(vendor) {
      if (vendor && vendor.hospital) {
        this.form.second_party_information.hospital_name = vendor.hospital;
      }
    },
    onPurposeWithChanged($event, event, index) {
      const { purpose_with } = event;
      let purpose =
        'Untuk meningkatkan kesadaran dan pengetahuan dari {peserta} di bidang {bidang/subjek pengetahuan} / ' +
        'to increase awareness and knowledge of {participants} in the field of {area/subject of knowledge}';
      if (purpose_with.peserta) {
        purpose = purpose.replace('{peserta}', purpose_with.peserta);
      }
      if (purpose_with.bidang) {
        purpose = purpose.replace(
          '{bidang/subjek pengetahuan}',
          event.purpose_with.bidang
        );
      }
      if (purpose_with.participant) {
        purpose = purpose.replace(
          '{participants}',
          event.purpose_with.participant
        );
      }
      if (purpose_with.subject) {
        purpose = purpose.replace(
          '{area/subject of knowledge}',
          event.purpose_with.subject
        );
      }
      this.events[index].purpose = purpose;
    }
  }
};
</script>

<style>
.tab-events .v-slide-group__wrapper {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
